export default __webpack_public_path__ + "static/media/ir_logo.18eed5c0.png";